module.exports = __webpack_public_path__ + "img/37.3bc9023e.jpg";